import { prefixCls } from '~/settings/designSetting'
export const useGlobSetting= () => {
  return {
    prefixCls
  }
}
